import { z } from 'zod';

/** Office ("Agente responsable") admin-management DTOs. */

export const createOfficeSchema = z.object({
  name: z.string().trim().min(1).max(120),
});
export type CreateOfficeDto = z.infer<typeof createOfficeSchema>;

export const updateOfficeSchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  active: z.boolean().optional(),
});
export type UpdateOfficeDto = z.infer<typeof updateOfficeSchema>;
